'use client';

import React from 'react';
import LegalHero from './LegalHero';
import RegistrationDetails from './RegistrationDetails';
import ComplianceInfo from './ComplianceInfo';

interface LegalInteractiveProps {
  className?: string;
}

const LegalInteractive = ({ className = '' }: LegalInteractiveProps) => {
  return (
    <div data-component-id="src/app/legal/components/LegalInteractive.tsx:14:4" data-component-path="src/app/legal/components/LegalInteractive.tsx" data-component-line="14" data-component-end-line="18" data-component-file="LegalInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`min-h-screen bg-white ${className}`}>
      <LegalHero data-component-id="src/app/legal/components/LegalInteractive.tsx:15:6" data-component-path="src/app/legal/components/LegalInteractive.tsx" data-component-line="15" data-component-end-line="15" data-component-file="LegalInteractive.tsx" data-component-name="LegalHero" data-component-content="%7B%22elementName%22%3A%22LegalHero%22%7D" />
      <RegistrationDetails data-component-id="src/app/legal/components/LegalInteractive.tsx:16:6" data-component-path="src/app/legal/components/LegalInteractive.tsx" data-component-line="16" data-component-end-line="16" data-component-file="LegalInteractive.tsx" data-component-name="RegistrationDetails" data-component-content="%7B%22elementName%22%3A%22RegistrationDetails%22%7D" />
      <ComplianceInfo data-component-id="src/app/legal/components/LegalInteractive.tsx:17:6" data-component-path="src/app/legal/components/LegalInteractive.tsx" data-component-line="17" data-component-end-line="17" data-component-file="LegalInteractive.tsx" data-component-name="ComplianceInfo" data-component-content="%7B%22elementName%22%3A%22ComplianceInfo%22%7D" />
    </div>
  );
};

export default LegalInteractive;
